import { Modal as ModalAntd, type ModalProps } from "antd"
import cn from "classnames"
import { useCallback } from "react"

import { isSubmitAllowedOnElement } from "@/helpers/utils"

import styles from "./Modal.module.scss"

export const Modal = (props: ModalProps) => {
  const { okButtonProps, afterOpenChange, rootClassName, ...rest } = props

  const handleOnKeyboard = useCallback((event: KeyboardEvent) => {
    const element = isSubmitAllowedOnElement(event)

    if (!element) return

    const submitButton = element
      .closest(".ant-modal-wrap")
      ?.querySelector('button[type="submit"]') as HTMLButtonElement

    if (submitButton) submitButton.click()
  }, [])

  return (
    <ModalAntd
      rootClassName={cn(styles.container, rootClassName)}
      okButtonProps={{ htmlType: "submit", ...okButtonProps }}
      afterOpenChange={(open) => {
        if (open) document.addEventListener("keydown", handleOnKeyboard, true)
        else document.removeEventListener("keydown", handleOnKeyboard, true)

        afterOpenChange?.(open)
      }}
      {...rest}
    />
  )
}

Modal.useModal = ModalAntd.useModal
